import { cn } from "@/lib/utils"
import FaIcon from "../layout/FaIcon"
import classes from "./loader.module.css"

export default function LoaderMain() {
    return (
        <div className="w-full h-screen flex flex-col items-center justify-center ">
           <div className="mt-6">
                <FaIcon style={cn("animate-bounce",classes.zoomIn)} />
           </div>
        </div>
    )
}
